import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useAuth } from '~/hooks/auth';

interface SettingsPersonalProps {
  openMenu(): void;
}

const SettingsPersonal: React.FC<SettingsPersonalProps> = ({ openMenu }) => {
  const { t } = useTranslation();
  const { user } = useAuth();

  return (
    <div className="nk-block">
      <div className="nk-block-head nk-block-between">
        <div className="nk-block-head-content">
          <h5 className="nk-block-title">Informações Pessoais</h5>
          <div className="nk-block-des">
            <p>Visualize as informações relativas à sua conta.</p>
          </div>
        </div>
        <div className="nk-block-head-content align-self-start d-lg-none">
          <Link
            to="#menu"
            className="toggle btn btn-icon btn-trigger mt-n1"
            data-target="userAside"
            onClick={openMenu}
          >
            <em className="icon ni ni-menu-alt-r" />
          </Link>
        </div>
      </div>
      <div className="card card-bordered">
        <div className="nk-data data-list">
          <div
            className="data-item"
            data-toggle="modal"
            data-target="#profile-edit"
          >
            <div className="data-col">
              <span className="data-label">{t('index.name')}</span>
              <span className="data-value">{user.name}</span>
            </div>
            <div className="data-col data-col-end">
              <span className="data-more">
                <em className="icon ni ni-forward-ios" />
              </span>
            </div>
          </div>
          <div className="data-item">
            <div className="data-col">
              <span className="data-label">{t('index.email')}</span>
              <span className="data-value">{user.email}</span>
            </div>
            <div className="data-col data-col-end">
              <span className="data-more disable">
                <em className="icon ni ni-lock-alt" />
              </span>
            </div>
          </div>
          {/* <div
            className="data-item"
            data-toggle="modal"
            data-target="#profile-edit"
          >
            <div className="data-col">
              <span className="data-label">Phone Number</span>
              <span className="data-value text-soft">Not add yet</span>
            </div>
            <div className="data-col data-col-end">
              <span className="data-more">
                <em className="icon ni ni-forward-ios" />
              </span>
            </div>
          </div>
          <div
            className="data-item"
            data-toggle="modal"
            data-target="#profile-edit"
          >
            <div className="data-col">
              <span className="data-label">Date of Birth</span>
              <span className="data-value">29 Feb, 1986</span>
            </div>
            <div className="data-col data-col-end">
              <span className="data-more">
                <em className="icon ni ni-forward-ios" />
              </span>
            </div>
          </div>
          <div
            className="data-item"
            data-toggle="modal"
            data-target="#profile-edit"
            data-tab-target="#address"
          >
            <div className="data-col">
              <span className="data-label">Address</span>
              <span className="data-value">
                2337 Kildeer Drive,
                <br />
                Kentucky, Canada
              </span>
            </div>
            <div className="data-col data-col-end">
              <span className="data-more">
                <em className="icon ni ni-forward-ios" />
              </span>
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default SettingsPersonal;
